import { withInstall } from '@antdv/utils';
import AWatermark from './src/Watermark';

export const Watermark = withInstall(AWatermark);

export default Watermark;

export * from './src/interface';
export * from './src/props';
